import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { LockIcon } from '../../components/ui/icons';
import type { ProfileChip } from './profileChips';
import './profile.css';

interface ProfileInfoChipsProps {
  chips: readonly ProfileChip[];
}

export function ProfileInfoChips({ chips }: ProfileInfoChipsProps) {
  const { t } = useTranslation();

  if (chips.length === 0) return null;

  return (
    <div className="profile-chips" data-count={chips.length}>
      {chips.map(({ key, labelKey, value, Icon, locked }) => (
        <div className="profile-chip" key={key}>
          <span className="profile-chip__icon">
            <Icon size={16} />
          </span>
          <span className="profile-chip__text">
            <span className="profile-chip__label">
              {t(labelKey)}
              {locked && (
                <LockIcon
                  size={10}
                  role="img"
                  aria-hidden={false}
                  aria-label={t('profile.accessibility.fieldPrivate')}
                />
              )}
            </span>
            <span className="profile-chip__value" title={value}>{value}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
